import PathwayUpload from "../components/PathwayUpload";

const PathwayUploadPage = () => {
  return <PathwayUpload />;
};

export default PathwayUploadPage;
